"use client";

import styles from "./AuthorsMosaic.module.scss";
import { Configure } from "react-instantsearch";
import {
  createInstantSearchNextInstance,
  InstantSearchNext
} from "react-instantsearch-nextjs";
import AlgoliaPagination from "@/ui/algolia/AlgoliaPagination";
import AuthorsMosaicFilters from "@/ui/authorsMosaic/AuthorsMosaicFilters";
import AuthorsAlgoliaMosaic from "./AuthorsAlgoliaMosaic";
import { algoliaClient } from "@/lib/algolia/algolia-client";
import { algoliaIndexNameFor } from "@/lib/algolia/utils";
import { useCustomAlgoliaRouting } from "../posts-list/AlgoliaPostsMosaic/use-custom-algolia-routing";

const indexName = algoliaIndexNameFor("authors");
const searchClient = algoliaClient();
const algoliaInstance = createInstantSearchNextInstance();

type Props = {
  limit?: number;
};

const AuthorsMosaic = ({ limit = 12 }: Props) => {
  const routing = useCustomAlgoliaRouting(indexName);

  return (
    <div>
      <InstantSearchNext
        indexName={indexName}
        searchClient={searchClient}
        routing={routing}
        instance={algoliaInstance}
        future={{ preserveSharedStateOnUnmount: true }}
      >
        <Configure distinct={true} hitsPerPage={limit} />

        <AuthorsMosaicFilters className={styles.filters} />

        <AuthorsAlgoliaMosaic />

        <AlgoliaPagination />
      </InstantSearchNext>
    </div>
  );
};

export default AuthorsMosaic;
